import type { FC } from 'react';
import React from 'react';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ACRadio } from 'shared/components/common/Radio/Radio';

interface ACLOCGroupBtnProps {
  options: string[];
  label?: string;
  selectedOption: string;
  onButtonClick: (option: string) => void;
  className?: string;
  boldOption?: boolean;
  isShowTooltipIcon?: boolean;
  openModal?: () => void;
  isCustomQuote?: boolean;
}

export const ACLimitofCoverBtnGroup: FC<ACLOCGroupBtnProps> = ({
  options,
  label,
  selectedOption,
  onButtonClick,
  className,
  openModal,
  boldOption = false,
  isShowTooltipIcon = true,
  isCustomQuote,
}) => {
  return (
    <div className={className}>
      <div className="mb-2 font-semibold">
        {label}
        {isShowTooltipIcon && (
          <span onClick={openModal}>
            <FontAwesomeIcon
              icon={faCircleQuestion}
              style={{ color: '#382EBE' }}
              className="ml-1.5 hover:cursor-pointer"
              size="sm"
            />
          </span>
        )}
      </div>

      {options.map((option, index) => {
        const isSelected = option === selectedOption;
        return (
          <div
            className={`border rounded px-5 py-0.5 bg-[#F7F9FC] flex items-center justify-between mb-3 max-w-[405px] ${
              !isCustomQuote && 'hover:cursor-pointer'
            } ${isSelected && 'border-blue-700'}`}
            key={option}
            onClick={
              !isCustomQuote
                ? () => {
                    onButtonClick(option);
                  }
                : undefined
            }
            style={{
              opacity: isCustomQuote ? 0.5 : 1,
            }}
          >
            <div className="flex items-center">
              <ACRadio checked={isSelected} disabled={isCustomQuote} />

              <span className={`${boldOption ? 'font-semibold' : 'font-medium'} text-[15px]`}>
                {option}
              </span>
            </div>

            {index === 1 && (
              <div className="font-bold text-white bg-[#382EBE] rounded-full text-[11.5px] px-2.5 py-0 leading-5">
                MOST POPULAR
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
